<template>
  <v-app id="cloud-app">
    <v-snackbar top :timeout="6000" v-model="snackbar" :color="alertColor" text>
      {{ alertMsg }}
      <template v-slot:action="{ attrs }">
        <v-btn :color="alertColor" text v-bind="attrs" @click="snackbar = false">关闭</v-btn>
      </template>
    </v-snackbar>
    <router-view @alert="showAlert"></router-view>
  </v-app>
</template>

<script>
const alertTypes = new Set(['success', 'info', 'error'])

export default {
  name: 'App',
  data () {
    return {
      snackbar: false,
      alertMsg: '',
      alertType: ''
    }
  },
  computed: {
    alertColor () {
      if (alertTypes.has(this.alertType)) {
        return this.alertType
      } else {
        return 'info'
      }
    }
  },
  created () {
    this.$store.commit('retrieveToken')
    this.$store.dispatch('getErrorCode')
    // plat type
    this.$store.dispatch('getPlatType')
  },
  methods: {
    showAlert (arg) {
      this.alertMsg = arg.msg
      this.alertType = arg.type
      this.snackbar = true
    }
  }
}
</script>

<style>
  html {
    overflow-y: auto;
  }
</style>
